<template>
  <div class="d-flex justify-content-start">
    <h1 class="font-raleway-Light-30 p-2 pt-3 ps-0 pb-0 mt-5 mb-0 m-4">Buscador de Flotas</h1>
  </div>
  <div class="pt-5 mt-5 ms-2 ps-2">
    <div class="d-flex justify-content-start">
      <div class="row col-lg-12 pb-3">
        <div class="d-flex col-3">
          <MDBInput label="Nombre de la Flota" class="active" v-model="fleetName" @blur="getFleetName(fleetName)" />
        </div>
        <div class="d-flex col-lg-1">
          <MDBInput label="Versión" class="active" v-model="version" disabled />
        </div>
      </div>
    </div>
    <div class="d-flex row justify-content-start">
      <div class="col-md-3">
        <select class="form-select active" v-model="types" @change="selectType">
          <option v-for="option in options" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="d-flex col-lg-3">
        <select class="form-select active" v-model="selectedClient" v-if="types === 'Cliente' && clients.length !== 0">
          <option v-for="option in clients" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
        <select class="form-select active" v-model="selectedWorker"
          v-if="types === 'Trabajador' && workers.length !== 0" @change="getVersion()">
          <option v-for="option in workers" :key="option" :value="option">
            {{ option }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between col-md-5 ps-2 pb-2">
    <div>
      <h1 class="font-raleway-regular-23 p-2 pt-3 pb-0 mb-0">Logs</h1>
    </div>
    <div class="ps-5 ms-5">
      <h1 class="font-raleway-regular-23 p-2 pt-3 pb-0 mb-0">Usuario</h1>
    </div>
  </div>
  <div class="row">
    <div class="d-flex align-items-center">
      <div class="pt-5 mt-1 ms-3">
        <MDBBtn color="success" @click="getLogs()">Obtener Logs</MDBBtn>
      </div>
      <div class="d-flex align-items-start flex-column ps-2 ms-1 pt-0">
        <div class="col-12">
          <label class="ms-3 font-roboto-regular-12">Log de tareas <br> de equipo</label>
          <div class="d-flex mt-3 ps-0 ms-0">
            <MDBBtn color="success" @click="printTaskLog()">Imprimir Logs</MDBBtn>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-start flex-column ps-2 ms-1 mt-1 pt-1">
        <div class="col-12">
          <label class="ms-2 font-roboto-regular-12">Log de mensajes <br>atrasados de equipo </label>
          <div class="d-flex mt-2 ps-0 ms-0">
            <MDBBtn color="success" @click="lastMessagesLog()">Imprimir Logs</MDBBtn>
          </div>
        </div>

      </div>
      <div class="d-flex align-items-center justify-content-between col-md-5 ps-2 ms-3 pt-4 mt-4">
        <MDBBtn color="warning" class="mt-2" @click="disconnect()">Desconectar Usuario</MDBBtn>
      </div>
    </div>
  </div>
  <div class="col-9">
    <div class="d-flex align-items-center justify-content-between col-md-6 ps-2 pt-5">
      <div>
        <h1 class="font-raleway-regular-23 ms-1 me-0 pt-3 pb-0 mb-0">Tareas</h1>
      </div>
      <div>
        <h1 class="font-raleway-regular-23 pe-4 pt-3 pb-0 mb-0">Mensajes</h1>
      </div>
      <div>
        <h1 class="font-raleway-regular-23 pe-4 pt-3 pb-0 mb-0">Transiciones</h1>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="d-flex align-items-center">
      <div class="d-flex align-items-start flex-column col-1 ps-2 ms-2 mt-2">
        <div class="col-12 pt-2 mt-3">
          <label class="mb-2 col-12 pt-0 pb-1 font-roboto-regular-12">Eliminar Tarea</label>
          <div class="d-flex col-12">
            <MDBInput label="ID Task" class="active" v-model="idTaskDelete" />
          </div>
          <div class="d-flex pt-3">
            <MDBBtn class="px-3" color="danger" @click="deleteTask(idTaskDelete)">Eliminar</MDBBtn>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-start flex-column col-2 ps-4 ms-2">
        <div class="col-12 mt-3">
          <label class="mb-2 ps-1 pt-0 pb-1 col-12 font-roboto-regular-12">Eliminar mensajes <br>encolados por ID de
            mensaje</label>
          <div class="d-flex col-11">
            <MDBInput label="ID Message" class="active" v-model="idMessage" />
          </div>
          <div class="d-flex pt-3">
            <MDBBtn class="px-3" color="danger" @click="deleteMessage(idMessage)">Eliminar</MDBBtn>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-start flex-column col-2 pe-2">
        <div class="col-12 pt-2 mt-2 ms-2">
          <label class="mb-2 pt-0 pb-1 font-roboto-regular-12">Sincronizar <br> transiciones guardadas</label>
          <div class="d-flex col-12">
            <MDBInput label="ID Task" class="active" v-model="idTaskSync" />
          </div>
          <div class="d-flex col-12 pt-3">
            <MDBInput label="Correo de FeedBack" class="active" v-model="feedBackEmail" />
          </div>
          <div class="d-flex pt-3">
            <MDBBtn class="text-white" color="info" @click="syncTransitions(idTaskSync, feedBackEmail)">Sincronizar
            </MDBBtn>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-start flex-column col-3 ps-3">
        <label class="mb-2 pt-0 pb-1 font-roboto-regular-12">Enviar mensaje falso</label>
        <MDBTextarea label="Insert json" rows="4" v-model="fakeMessage" />
      </div>
      <div class="row pt-4 mt-1 ps-3">
        <div class="col-md-10">
          <select class="form-select active" v-model="selectedCheckpoint" @change="selectCheckpoint">
            <option v-for="option in checkpoints" :key="option" :value="option">
              {{ option }}
            </option>
          </select>
        </div>
        <div class="d-flex pt-3">
          <MDBBtn class="text-white" color="info" @click="sendFakeMessage()">Enviar Mensaje Falso</MDBBtn>
        </div>
      </div>
    </div>
  </div>
  <ToastComponent ref="toast" />
</template>

<script>
// import { fbapi } from '@fieldbeat/vuejs';
import FleetService from '../services/mobileService/searchFleet.service';
import ToastComponent from '../utils/toast.vue';

export default {
  name: 'SearchFleet',
  components: {
    ToastComponent
  },
  data() {
    return {
      toastMessage: '',
      fleetName: '',
      version: '',
      idTaskDelete: '',
      options: ['Cliente', 'Trabajador'],
      clients: ['Client 1', 'Client 2', 'Client 3', 'Client 4', 'Client 5'],
      workers: [],
      workersData: [],
      checkpoints: ['CHECKPOINT', 'LOGOUT', 'OFFLINE_LOCATIONS', 'REQUEST_INFORMATION', 'TASK', 'TASK_FINISHED_ITEM', 'TASK_HISTORY', 'TRANSITION'],
      types: '',
      selectedClient: '',
      selectedWorker: '',
      selectedCheckpoint: '',
      registration_id: '',
      fakeMessage: '',
      phone: []
    };
  },
  mounted() {
    this.selectedCheckpoint = this.checkpoints[0];
    this.types = this.options[1];
    this.selectedClient = this.clients[0];
    this.selectedWorker = this.workers[0];
  },
  methods: {
    async getFleetName(fleetName) {
      try {
        if (!fleetName) return;
        const { workers, workersData, phone } =
          await FleetService.getFleetName(fleetName, this.$fieldbeat);
        this.workers = workers;
        this.workersData = workersData;
        this.phone = phone;
      } catch (error) {
        const msg = error?.response?.data?.error || error?.message || 'Error al consultar la flota';
        this.$refs.toast?.showToast(true, msg);
      }
    },
    getVersion() {
      FleetService.getVersion(this.selectedWorker, this.workersData)
        .then(version => {
          if (version && version !== undefined) {
            this.version = version;
          } else {
            this.$refs.toast?.showToast(true, 'No se ha encontrado la versión');
          }
        })
    },
    async getLogs() {
      if (this.selectedWorker) {
        const response = await FleetService.getLogs(this.selectedWorker, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async printTaskLog() {
      if (this.selectedWorker) {
        const response = await FleetService.printTaskLog(this.selectedWorker, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async lastMessagesLog() {
      if (this.selectedWorker) {
        const response = await FleetService.lastMessagesLog(this.selectedWorker, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async disconnect() {
      if (this.selectedWorker) {
        const response = await FleetService.disconnect(this.selectedWorker, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async deleteTask(id) {
      if (id > 0 && this.selectedWorker) {
        const response = await FleetService.deleteTask(this.selectedWorker, id, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async deleteMessage(id) {
      if (id > 0 && this.selectedWorker) {
        const response = await FleetService.deleteMessage(this.selectedWorker, id, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async syncTransitions(id, email) {
      if (this.selectedWorker && id && email) {
        const response = await FleetService.syncTransitions(this.selectedWorker, id, email, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    async sendFakeMessage(option, fakeMessage) {
      if (option && fakeMessage && this.selectedWorker) {
        const response = await FleetService.sendFakeMessage(this.selectedWorker, option, fakeMessage, this.$fieldbeat);
        this._handleResponse(response);
      }
    },
    _handleResponse(res) {
      // defensa extra por si llega algo raro en prod
      if (!res || typeof res !== 'object') {
        this.$refs.toast?.showToast(true, 'Respuesta inválida');
        return;
      }
      switch (res.code) {
        case 201: this.$refs.toast?.showToast(false, 'Acción realizada con éxito'); break;
        case 400: this.$refs.toast?.showToast(true, res.json?.error || 'Error desconocido'); break;
        case 403: this.$refs.toast?.showToast(true, res.json?.error); break;
        case 412: this.$refs.toast?.showToast(true, 'No hay id de Firebase para enviar el mensaje'); break;
        default:
          if (res.code && res.code !== 200) this.$refs.toast?.showToast(true, `Error (${res.code})`);
      }
    }
  }
};
</script>
<style>
.form-outline:disabled {
  background-color: #eceef1;
  color: gray;
}
</style>